import { render, staticRenderFns } from "./nvisite.vue?vue&type=template&id=2b8b6df1"
import script from "./nvisite.vue?vue&type=script&lang=js"
export * from "./nvisite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports